import { Pcr } from '../../lib/types/models/pcr/pcr'
import { PcrInput } from '../../lib/types/models/pcr/pcr-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createPcr(data: PcrInput) {
  return restApiClient.url(constructApiUrl(API.pcr.create.url, null)).post<Pcr, PcrInput>(data)
}
